import { useToast } from '@cad-arc';
import { ContextMenuItemView, UnitContextMenuClickParams } from '@mark43/cad-api';
import { createApiErrorHandler } from '@m43/core';
import { errorOccurredWhile } from '../common/helpers/error-occurred-while';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';
import { useSetUnitsOffDutyApi } from './use-set-units-off-duty-api';

export function OffDutyItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: UnitContextMenuClickParams;
}): React.ReactElement {
    const setUnitsOffDuty = useSetUnitsOffDutyApi();
    const toast = useToast();
    return (
        <ContextMenuItem
            dataPendoId="menu-item-off-duty"
            contextMenuItemView={contextMenuItemView}
            onSelect={() => {
                setUnitsOffDuty([clickParams.unitId]).catch(
                    createApiErrorHandler(() => {
                        toast({
                            status: 'error',
                            description: errorOccurredWhile(`transitioning unit to Off Duty`),
                        });
                    })
                );
            }}
        />
    );
}
